import { inject, Pipe, PipeTransform } from "@angular/core";
import { Observable } from "rxjs";
import { UserNameService } from "../../services/user-name/user-name.service";

@Pipe({
	name: "userFullName"
})
export class UserFullNamePipe implements PipeTransform {
	private userNameService = inject(UserNameService);

	transform(userId: string): Observable<string> {
		return this.userNameService.getUserNameFromId(userId);
	}
}
